export default __webpack_public_path__ + "static/media/img_men.21f820de.png";